"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Currencies_1 = require("./Currencies");
/** Formats numeric values into currencies based on locale for display.
 *  @param value: The number to format.
 *  @param locale: passed in locale; default is 'en-US' if not passed in.
 */
function Format(value, locale, hideNull) {
    let tempPrice = value;
    if (Number.isNaN((value !== null && value !== void 0 ? value : NaN)) || value === -1) {
        if (!!hideNull) {
            return '';
        }
        tempPrice = 0;
    }
    return new Intl.NumberFormat((locale !== null && locale !== void 0 ? locale : 'en-US'), {
        style: 'currency',
        currency: GetCurrency(locale),
        currencyDisplay: 'symbol'
    }).format(tempPrice);
}
exports.Format = Format;
/** Formats the value as currency. Negative values will be displayed as ($100.00) rather than -$100.00 */
function NegativeFormat(value, locale, hideNull) {
    let newVal = Format(Math.abs(value), locale, hideNull);
    return (value < 0) ? '(' + newVal + ')' : newVal;
}
exports.NegativeFormat = NegativeFormat;
/** Removes formatted currency values (based on locale) and returns a numeric value.
 *  @param value: The formatted currency value.
 *  @param locale: passed in locale; default is 'en-US' if not passed in.
 */
function RemoveCurrencyFormat(value, locale) {
    let tempValue = value;
    if ((typeof value !== 'string' || value.trim().length === 0)) {
        tempValue = '$0.00';
    }
    else if (locale === 'fr-CA') {
        tempValue = value.replace(/,+/g, '.');
    }
    return Number(tempValue.replace(/[^0-9.-]+/g, ''));
}
exports.RemoveCurrencyFormat = RemoveCurrencyFormat;
/** Returns the ISO 4217 Currency Code for the specified locale. */
function GetCurrency(locale) {
    return (locale === 'fr-CA' || locale === 'en-CA') ? 'CAD' : 'USD';
}
exports.GetCurrency = GetCurrency;
/** Returns the Currency Smybol for the specified locale. */
function GetCurrencySymbol(locale) {
    return Currencies_1.default[GetCurrency(locale)];
}
exports.GetCurrencySymbol = GetCurrencySymbol;
//# sourceMappingURL=CurrencyFormat.js.map